import axios from "axios";
import { toast } from "react-toastify";
import {
  ADD_CUSTOMER_HEAD_ERROR,
  ADD_CUSTOMER_HEAD_LOADING,
  ADD_CUSTOMER_HEAD_SUCCESS,
  CLEAR_CUSTOMER_HEAD_DATA,
} from "../Constants/CustomerHeadConstants";
import { API_HOST } from "../../api_utils";

export const addCustomerHead = (customerData) => async (dispatch) => {
  dispatch({ type: ADD_CUSTOMER_HEAD_LOADING });
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const { data } = await axios.post(
    `${API_HOST}/api/customer_head/add_cutomer`,
    customerData,
    config
  );

  if (data) {
    if (data.message) {
      dispatch({
        type: ADD_CUSTOMER_HEAD_ERROR,
        payload: data.message,
      });
      toast.error(data.message);
    } else {
      dispatch({ type: ADD_CUSTOMER_HEAD_SUCCESS, payload: data });
      toast.success("Customer Added Successfully !!!");
    }
  }
};

export const clearCustomerHeadData = () => async (dispatch) => {
  console.log("dispatch here:::::");
  dispatch({ type: CLEAR_CUSTOMER_HEAD_DATA });
};
